import React     from 'react';
import ListStore from '@widesk-ui/stores/ListStore';

type ListContextType = { listStore?: ListStore; }

const ListContext = React.createContext<ListContextType>({ listStore: undefined });

export default ListContext;
